import { Button, Typography } from '@mui/material';
import Image from 'src/components/image';
import { useLocales } from 'src/locales';
import { useCreateChatChannelModal } from '../shared/CreateChatChannelModal';
import { ChatCreateTitle } from '../shared/CreateChatChannelModal/constants';
import { P2PImageContainer } from './styles';

export const ChatNavItemP2PStart = () => {
  const { translate } = useLocales();
  const { showChatDetailsDialog } = useCreateChatChannelModal();

  return (
    <P2PImageContainer>
      <Image
        disabledEffect
        src="/assets/illustrations/illustration_p2p_invite_members.svg"
      />
      <Typography variant="subtitle1" color="primary">
        {translate('communicate.direct.start_a_conversation')}
      </Typography>
      <Typography variant="caption" color="text.secondary" align="center">
        {translate('communicate.direct.start_a_conversation_body_content')}
      </Typography>

      <Button
        variant="contained"
        color="primary"
        sx={{ mt: 2 }}
        onClick={(e) => {
          e.stopPropagation();
          showChatDetailsDialog({ tab: ChatCreateTitle.DM });
        }}
      >
        {translate('chat_ai.empty_messages.start_conversation')}
      </Button>
    </P2PImageContainer>
  );
};
